var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},_vm._l((_vm.planList),function(step){return _c('PlanCard',{key:step._id,attrs:{"step":step}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }